export default {
    durationMinutes: 'ui.runtimessr.calbooking.duration.minutes',
    freeBookingPrice: 'ui.runtimessr.calbooking.meta.price.free',
    priceIncludesTax: 'ui.runtimessr.calbooking.meta.price.includes.tax',
    priceMightChangeMessage: 'ui.runtimessr.calbooking.meta.price.might.change',
    paidBookingNextStepButton:
        'ui.runtimessr.calbooking.paid.booking.next.step.button',
};
